import { marked } from 'marked'

marked.setOptions({
  breaks: true,
  gfm: true,
})

function decodeHtmlEntities(text) {
  if (typeof document === 'undefined') {
    return text
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
  }
  const ta = document.createElement('textarea')
  ta.innerHTML = text
  return ta.value
}

/**
 * 列表摘要等：去掉标签并解码 &nbsp; 等实体，再压成单行空格（CKEditor 首行空格常存为 &nbsp;）。
 * @param {string|null|undefined} raw
 * @param {number} [maxLen] 最大字符数，超出加省略号
 */
export function htmlToPlainExcerpt(raw, maxLen) {
  if (raw == null || raw === '') return ''
  let s = String(raw).replace(/<[^>]*>/g, ' ')
  s = decodeHtmlEntities(s)
  s = s.replace(/[\s\u00A0\uFEFF]+/g, ' ').trim()
  if (!s) return ''
  if (maxLen != null && maxLen > 0 && s.length > maxLen) {
    return s.slice(0, maxLen) + '…'
  }
  return s
}

/**
 * 后台富文本：旧数据为 Strapi 默认 Markdown；CKEditor 字段一般为 HTML。
 */
export function richContentToHtml(raw) {
  const s = raw == null ? '' : String(raw)
  if (!s.trim()) return ''
  const t = s.trim()
  if (/^<[a-z!/]/i.test(t)) return s
  return marked.parse(s)
}
